import { apiCall } from "../service/api-service";

export const getOpportunityListApi = async (params) => {
  return apiCall("GET", "opportunity", null, { params });
};

export const createOpportunityApi = async (data) => {
  return apiCall("POST", "opportunity", data);
};

export const updateOpportunityApi = async (id, data) => {
  return apiCall("PUT", `opportunity/${id}`, data);
};

export const getOpportunityEditApi = async (id) => {
  return apiCall("GET", `opportunity/edit/${id}`);
};

export const getOpportunityViewApi = async (id) => {
  return apiCall("GET", `opportunity/view/${id}`);
};

export const updateOpportunityStageApi = async (id, stage) => {
  return apiCall("PUT", `opportunity/update_stage/${id}`, { stage });
};

export const bulkDeleteOpportunitiesApi = async (ids) => {
  return apiCall("DELETE", "opportunity/bulk_delete", { ids });
};

export const getOpportunityAttachmentsApi = async (id) => {
  return apiCall("GET", `opportunity/attachment/${id}`);
};

export const addOpportunityAttachmentApi = async (id, attachment) => {
  return apiCall("POST", `opportunity/add_attachment/${id}`, { attachment });
};

export const deleteOpportunityAttachmentApi = async (id) => {
  return apiCall("DELETE", `opportunity/delete_attachment/${id}`);
};

// Stages, shared by the list filter, the create form and the view page's
// stage picker. Mirrors OpportunityController::STAGES.
export const OPPORTUNITY_STAGES = ["New", "Qualification", "Proposal", "Negotiation", "Won", "Lost"];

export const STAGE_COLORS = {
  New: { bg: "#EEF2FF", text: "#3D4AF5" },
  Qualification: { bg: "#EBE0FF", text: "#6929E2" },
  Proposal: { bg: "#FFF6E9", text: "#B8860B" },
  Negotiation: { bg: "#FFF6E9", text: "#FFBA57" },
  Won: { bg: "#CDFFE2", color: "#17B65B", text: "#17B65B" },
  Lost: { bg: "#FDF0F0", text: "#D61916" },
};

export const getOpportunityDashboardApi = async (params) => {
  return apiCall("GET", "opportunity/dashboard", null, { params });
};

export const getOpportunityAiSummaryApi = async (id, payload = {}) => {
  return apiCall("POST", `opportunity/ai_summary/${id}`, payload);
};
